import { render } from "./CustomerTagsView.vue?vue&type=template&id=3dca2604&scoped=true"
import script from "./CustomerTagsView.vue?vue&type=script&lang=js"
export * from "./CustomerTagsView.vue?vue&type=script&lang=js"

import "./CustomerTagsView.vue?vue&type=style&index=0&id=3dca2604&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dca2604"]])

export default __exports__